export enum EGarageStatus {
  Cooperative = 1,
  Ownership = 2,
  Agreement = 3,
}
